import PropTypes from 'prop-types';

export default PropTypes.shape({
	DownloadLink: PropTypes.string,
	ExternalMediaID: PropTypes.string,
	ID: PropTypes.number.isRequired,
	SourceContentImage: PropTypes.string,
	SourceContentUrl: PropTypes.string,
	ThumbnailLink: PropTypes.string,
	ThumbnailLinkUrl: PropTypes.string,
	Type: PropTypes.number.isRequired,
	Version: PropTypes.number.isRequired,
	ViewURL: PropTypes.number.isRequired,
});
